import { render } from "./industries.vue?vue&type=template&id=9eba843a&scoped=true"
import script from "./industries.vue?vue&type=script&lang=js"
export * from "./industries.vue?vue&type=script&lang=js"

import "./industries.vue?vue&type=style&index=0&id=9eba843a&scoped=true&lang=css"
import "./industries.vue?vue&type=style&index=1&id=9eba843a&scoped=true&lang=css"

import exportComponent from "C:\\Master\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eba843a"]])

export default __exports__